import styled, { css } from 'styled-components';
import media from 'themes/media';

const ReactionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: calc(100% - 32px);
  margin-top: 16px;
  & img {
    width: 42px;
    height: 42px;
  }
  ${media.lessThan('mobileL')`
    max-width: 250px;
    & img{
        height: 56px;
        width: 56px;
    }
  `}
`;
const Feedback = styled.div`
  top: calc(100vh - 232px);
  left: 100vw;
  width: 250px;
  height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  background: #ffffff;
  box-shadow: 0px 0px 19px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  z-index: 2147483601;

  h3 {
    margin: 0;
    margin-top: 8px;
    text-align: center;
    font-size: 16px;
    max-width: 169px;
  }
  h4 {
    background-color: #2d9cdb1a;
    width: 100%;
    text-align: center;
    line-height: 32px;
    margin-top: 0;
    font-size: 12px;
  }
  h3 p {
    display: inline;
    color: #2d9cdb;
  }
  & textarea {
    resize: none;
    margin-top: 8px;
    padding: 8px;
    outline: none;
    border-radius: 6px;
    border: 2.5px solid #2d9cdb;
    width: 100%;
    height: 96px;
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    color: black;
  }
  @keyframes comeoutDesktop {
    to {
      transform: translateX(-266px);
    }
  }
  @keyframes comeBackDesktop {
    to {
      transform: translateX(266px);
    }
  }

  ${media.greaterThan('mobileL')`
    ${({ expanded }) =>
      expanded &&
      css`
        top: calc(100vh - 450px);
        transition: top 1s ease-in-out;
        height: 435px;

        & h3 {
          margin-top: 8px;
        }
      `}
    ${({ open }) =>
      open &&
      css`
        animation: comeoutDesktop 1s ease-in-out both;
      `}
      ${({ open }) =>
        !open &&
        css`
          left: calc(100vw - 266px);
          animation: comeBackDesktop 1s ease-in-out forwards;
        `}
    `}
  ${({ isFeedbackFormInvisible }) =>
    isFeedbackFormInvisible &&
    css`
      display: none;
    `}
  ${media.lessThan('mobileL')`
    top: 55vh;
    width: 100%;
    height: 45vh;
    left: 0;
    box-shadow: none;
    border-radius: 12px;
    & h3 {
        max-width: 210px;
        font-weight: 700;
        margin-top: 0;
    }
    & h4{
        display: none;
    }
    ${({ open }) =>
      open &&
      css`
        animation: comeOutMobile 1s ease-in-out forwards;
      `}
    ${({ expanded }) =>
      expanded &&
      css`
        transform: translateY(-200px);
        transition: transform 1s ease-in-out;
        min-height: -webkit-fill-available;
        & button {
          width: calc(100vw - 32px);
          max-width: 450px;
        }
        ${({ innerHeight }) =>
          innerHeight < 400 &&
          css`
            top: 0;
            height: 100vh;
            ${({ innerHeight }) =>
              innerHeight < 300 &&
              css`
                .reactionsWrapper,
                .feedbackQuestion {
                  display: none;
                }
                & textarea {
                  height: 72px;
                }
              `}
          `}
      `}

      ${({ open }) =>
        !open &&
        css`
          transform: translateY(900px);
          transition: transform 2s ease-in-out;
        `}
        ${({ innerHeight }) =>
          innerHeight < 400 &&
          css`
            transform: translateY(-45vh);
            height: 100vh;
            width: 100vw;
          `}
    @keyframes comeOutMobile {
        0% {
          top: 100vh;
        }
        100% {
          top: 55vh;
        }
    @keyframes comeBackMobile {
      100% {
        top: 100vh
      }
    }
  `}
`;
const Close = styled.div`
  height: 28px;
  width: calc(100% - 24px);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px 0 16px 0;
  & img {
    cursor: pointer;
    width: 12px;
    height: 12px;
  }
  & h4 {
    display: none;
    ${media.lessThan('mobileL')`
      display: inline-block;
      width: fit-content;
      background-color: transparent;
      font-size: 16px;
      font-weight: 500;
      line-height: 19px;
    `}
  }
  ${media.lessThan('mobileL')`
    width: 100%;
    background-color: #2D9CDB1A;
    border-radius: 8px 8px 0 0;
    padding: 21px;
    justify-content: space-between;
    margin-bottom: 16px;
    & img{
        width: 14px;
        height: 14px;
    }
  `}
`;
const Reaction = styled.div`
  cursor: pointer;
  position: relative;

  $ img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
const SatisfiedChosen = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  ${media.lessThan('mobileL')`
    margin-top: 32px;
  `}
`;
const NegativeFeedback = styled.div`
  padding: 0 16px 0 16px;
  & h3 {
    max-width: 100%;
    font-size: 14px;
  }
  transition: all 1s ease-in-out;
`;
const SendButton = styled.button`
  display: block;
  width: 100%;
  margin-top: 4px;
  outline: none;
  border: none;
  height: 32px;
  background-color: #2d9cdb;
  border-radius: 4px;
  color: white;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    transform: scale(1.01);
  }

  ${({ feedbackText }) =>
    feedbackText === '' &&
    css`
      opacity: 0.5;
      cursor: block;
    `}
`;
const GetHelpButton = styled(SendButton)`
  margin-top: 4px;
  background-color: transparent;
  border: 1.5px solid #2d9cdb;
  color: #2d9cdb;
`;
const FeedbackTextSent = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  & h1 {
    text-align: center;
    width: calc(100% - 32px);
    margin: 0 0 24px 0;
    border-bottom: 1px solid #2d9cdb;
  }
`;
export {
  Feedback,
  Close,
  ReactionsWrapper,
  Reaction,
  SatisfiedChosen,
  NegativeFeedback,
  SendButton,
  GetHelpButton,
  FeedbackTextSent,
};
